/**
 * Royal Footer accordion sync
 * — Na desktope (container >= 750px) sú všetky <details class="frc-col"> vždy open
 * — Na mobile (container < 750px) sú collapsed; užívateľ ich toggle-uje klikom
 * — Reaguje na resize (browser, theme editor zooming)
 *
 * Žiadne závislosti. Bezpečné voči vacancy.
 */
(function () {
  'use strict';

  function syncFooter(inner) {
    if (!inner) return;
    var isMobile = inner.offsetWidth < 750;
    var cols = inner.querySelectorAll('details.frc-col');
    cols.forEach(function (d) {
      if (isMobile) {
        // Pri prvom prechode na mobile zavri všetky stĺpce
        if (!d.dataset.mobileSet) {
          d.open = false;
          d.dataset.mobileSet = '1';
        }
      } else {
        d.open = true;
        delete d.dataset.mobileSet;
      }
    });
  }

  function syncAll() {
    document.querySelectorAll('.frc-inner').forEach(syncFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  var raf;
  window.addEventListener('resize', function () {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(syncAll);
  });

  // Shopify theme editor — re-sync on section reload
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var inner = e.target.querySelector('.frc-inner');
      if (inner) syncFooter(inner);
    });
  }
})();
